import {useQuery} from '@tanstack/vue-query';
import axios from 'axios';

const useActionCategories = (onlyHidden = false) => useQuery({
  queryKey: ['action-categories', onlyHidden],
  queryFn: async () => {

    const query = new URLSearchParams();
    query.append('onlyHidden', onlyHidden ? '1' : '0');

    const url = '/ajax/v2/actions/categories' + '?' + query.toString();
    const {data} = await axios.get(url);

    return data.data;
  }
});

export default useActionCategories;
